import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ATSScorePage from './components/ATSScorePage';

function App() {
  return (
    <BrowserRouter>
      <div className="App overflow-x-hidden">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/ats-score" element={<ATSScorePage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
